module.exports = __webpack_public_path__ + "img/mirror13.294e2be4.jpg";